
import { defineComponent, ref, onMounted } from "vue";
import Permission from "@/core/config/Permission";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance"

export default defineComponent({
  name: "customers-listing",
  components: {
  },
  data() {
    return {
    }
  },
  props: {
    campaignId: String,
    type: String,
  },
  methods: {


  },
  async created() {
    // this.getData()

  },
  setup(props) {
    const formData = ref({
        email:''
    })
    const formRef = ref();
    const submit = () => {
      if (!formRef.value) {
        return;
      }
      formRef.value.validate(async (valid) => {
        if (valid) {
          let data = {
            "email": formData.value.email,
            "campaignId": props.campaignId,
            "type": props.type
          }
          console.log('data',data)
          await axios.post( `/admission/mail/send/test`,data)
            .then(( {data} ) => {
                Swal.fire({
                    html: `Gửi mail test thành công. Vui lòng kiểm tra mail`,
                    icon: 'success',
                    buttonsStyling: false,
                    confirmButtonText: "Đóng",
                    customClass: {
                    confirmButton: "btn btn-primary",
                    },
                    }).then(() => {
                        Swal.close()
                    },300);
                })
            .catch(({ response }) => {
                Swal.close()
                console.log('err',response)
            });

        } else {
            return false;
        }
      });
    };
    return {
      Permission,
      formData,
      submit,
      formRef
      //
    };
  },
});
